<div class="pt-(--space-1)">
  @switch (detail().type) {
    @case (LogDetailChangeType.UPDATE) {
      <div class="flex flex-row gap-(--gap-tight) items-center">
        <span class="bg-(--surface-1) px-(--space-2) py-(--space-1) rounded-(--radius-md)">
          {{ getFormattedValue(detail().oldValue) }}
          @if (!getFormattedValue(detail().oldValue)) {
            <i>{{ 'history.logContent.empty' | transloco }}</i>
          }
        </span>
        <ces-icon class="inline-flex items-center mx-(--space-1)" size="sm" containerSize="xs"> arrow_forward </ces-icon>
        <span class="bg-(--p-green-300) px-(--space-2) py-(--space-1) rounded-(--radius-md)">
          {{ getFormattedValue(detail().newValue) }}
          @if (!getFormattedValue(detail().newValue)) {
            <i>{{ 'history.logContent.empty' | transloco }}</i>
          }
        </span>
      </div>
    }
    @case (LogDetailChangeType.CREATE) {
      <span class="bg-(--p-green-300) px-(--space-2) py-(--space-1) rounded-(--radius-md) mr-(--space-1)">{{
        getFormattedValue(detail().newValue)
      }}</span>
      <span class="text-sm text-(color:--text-secondary)"> ({{ getCreatedText() }}) </span>
    }
    @case (LogDetailChangeType.DELETE) {
      <span class="bg-(--surface-1) px-(--space-2) py-(--space-1) rounded-(--radius-md)">
        {{ getFormattedValue(detail().oldValue) }}
      </span>
      <span class="text-sm text-(color:--text-secondary)"> ({{ getDeletedText() }}) </span>
    }
    @default {
      <span class="text-sm text-(color:--text-secondary)"> {{ 'history.logContent.modification' | transloco }} </span>
    }
  }
</div>
